import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const filterUsers = (state: IAppState) => state.userGroups.filterUsers;

export const getAutocompleteUsers = createSelector(
    filterUsers,
    (state: IFilterUsersState) => state.users
);

export const getFilterColumns = createSelector(
    filterUsers,
    (state: IFilterUsersState) => state.filterColumns
);

export const isLoadingUsers = createSelector(
    filterUsers,
    (state: IFilterUsersState) => state.isLoadingUsers
);
